.table {
  width: 100%;
}

@media (max-width: 599.95px) {
  .table thead {
    display: none;
  }

  .table tr {
    display: grid;
    gap: var(--tuna-spacing-1);
    padding: var(--tuna-spacing-2) 0;
    border-bottom: 1px solid var(--tuna-border-default);
  }

  .table td {
    display: flex;
    justify-content: space-between;
    border: none;
  }
}
